/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'project-contributors-picker.done': 'Concluído',
  'project-contributors-picker.go-back-label': 'Voltar',
  'project-contributors-picker.header': 'Selecione membros no projeto',
  'project-contributors-picker.your-teams-secondary-text':
    '{membersCount, plural, one {{membersCount,number} membro} other {{membersCount,number} membros}}',
  'project-contributors-picker.your-teams-secondary-text-focused':
    '{membersCount, plural, one {Selecione entre {membersCount,number} membro} other {Selecione entre {membersCount,number} membros}}',
  'project-contributors-picker.your-teams-title': 'Suas equipes',
  'project-fields.common.generic-error.description': 'Verifique a conexão com a Internet e tente outra vez.',
  'project-fields.common.generic-error.title': 'Algo deu errado',
  'project-fields.link-item.delete-label': 'Excluir',
  'project-fields.link-item.edit-label': 'Editar',
  'project-fields.project-contributes-to.add-goal-title': 'Adicionar meta',
  'project-fields.project-contributes-to.empty-title': 'Nenhuma meta',
  'project-fields.project-contributes-to.title': 'Contribui para',
  'project-fields.project-contributors.add-contributors-title': 'Adicionar colaboradores',
  'project-fields.project-contributors.empty-title': 'Nenhum colaborador',
  'project-fields.project-contributors.remove-contributor': 'Remover colaborador',
  'project-fields.project-contributors.remove-contributor-error-message': 'Não foi possível remover o colaborador',
  'project-fields.project-contributors.remove-team': 'Remover equipe',
  'project-fields.project-contributors.show-more': 'Mostrar mais',
  'project-fields.project-contributors.title': 'Colaboradores',
  'project-fields.project-contributors.view-profile': 'Visualizar perfil',
  'project-fields.project-contributors.view-profile-team': 'Visualizar perfil',
  'project-fields.project-focus-areas.title': 'Áreas de foco',
  'project-fields.project-followers.add-followers-title': 'Adicionar seguidores',
  'project-fields.project-followers.empty-title': 'Nenhum seguidor',
  'project-fields.project-followers.title': 'Seguidores',
  'project-fields.project-link-picker.aria-label': 'Links vistos há pouco',
  'project-fields.project-link-picker.invalid-link-input.error': 'Verifique se seu link é um URL válido.',
  'project-fields.project-link-picker.link-input.clear-label': 'Limpar link',
  'project-fields.project-link-picker.link-input.placeholder': 'Colar link ou pesquisar páginas visualizadas há pouco',
  'project-fields.project-link-picker.text-input.clear-label': 'Limpar texto',
  'project-fields.project-link-picker.text-input.placeholder': 'Texto a ser exibido (opcional)',
  'project-fields.project-links.add-links-title': 'Adicionar links',
  'project-fields.project-links.add-links-tooltip': 'Adicionar links para documentos, designs e muito mais',
  'project-fields.project-links.delete-link-button': 'Excluir link',
  'project-fields.project-links.edit-link-button': 'Editar link',
  'project-fields.project-links.empty-title': 'Nenhum link',
  'project-fields.project-links.title': 'Links',
  'project-fields.project-owner.title': 'Proprietário',
  'project-fields.project-start-date.add-start-date-title': 'Adicionar data de início',
  'project-fields.project-start-date.cancel-button': 'Salvar',
  'project-fields.project-start-date.creation-date': 'Este projeto foi criado em {creationDate}',
  'project-fields.project-start-date.edit-start-date-label': 'Editar data de início do projeto',
  'project-fields.project-start-date.empty-title': 'Nenhuma data de início',
  'project-fields.project-start-date.enter-start-date-title': 'Insira a data de início',
  'project-fields.project-start-date.open-calendar-label': 'Abrir o calendário',
  'project-fields.project-start-date.read-only':
    'Apenas colaboradores com acesso de edição podem alterar a data de início.',
  'project-fields.project-start-date.title': 'Data de início',
  'project-fields.project-state.archived': 'Arquivado',
  'project-fields.project-state.at-risk': 'Em risco',
  'project-fields.project-state.cancelled': 'Cancelado',
  'project-fields.project-state.completed': 'Concluído 🎉',
  'project-fields.project-state.off-track': 'Fora dos trilhos',
  'project-fields.project-state.on-track': 'Nos trilhos',
  'project-fields.project-state.paused': 'Pausado',
  'project-fields.project-state.pending': 'Pendente',
  'project-fields.project-status-picker.project-status-picker-more-button': 'Mais status',
  'project-fields.project-status.title': 'Status',
  'project-fields.project-tags.add-tags-title': 'Adicionar marcadores',
  'project-fields.project-tags.empty-title': 'Nenhum marcador',
  'project-fields.project-tags.title': 'Marcadores',
  'project-fields.project-target-date.picker-placeholder': 'Pendente',
  'project-fields.project-target-date.title': 'Data-alvo',
  'project-fields.project-work-items.show-all-non-final': 'Mostrar todos',
  'project-fields.project-work-items.show-less-non-final': 'Mostrar menos',
  'project-fields.project-work-tracked-picker.cancel-button': 'Salvar',
  'project-fields.project-work-tracked-picker.fallback-description':
    'Adicione um link para onde você está acompanhando o trabalho deste projeto',
  'project-fields.project-work-tracked-picker.fallback-invalid-url': 'Insira um URL válido',
  'project-fields.project-work-tracked-picker.no-recently-viewed-header': 'Pesquisar por tickets do Jira',
  'project-fields.project-work-tracked-picker.no-recently-viewed-result':
    'Pesquise ou adicione links para locais nos quais você está acompanhando o trabalho para este projeto.',
  'project-fields.project-work-tracked-picker.no-search-result':
    'Tente inserir de novo a chave do ticket do Jira, o URL ou usar termos diferentes para pesquisar.',
  'project-fields.project-work-tracked-picker.no-search-results-header': 'Não foi possível encontrar uma combinação',
  'project-fields.project-work-tracked-picker.recently-viewed-title': 'Visto há pouco',
  'project-fields.project-work-tracked-picker.results-title': 'Resultados',
  'project-fields.project-work-tracked-picker.search-placeholder': 'Pesquise no Jira ou adicione um link',
  'project-fields.project-work-tracked-picker.sync-form-description':
    'Vincule este projeto com o ticket do Jira selecionado e mantenha as informações com sincronização automática.',
  'project-fields.project-work-tracked-picker.sync-form-warning':
    'Observe que todos que podem ver esse ticket do Jira vão ver as informações do seu projeto.',
  'project-fields.project-work-tracked-picker.sync-with-jira-button': 'Sincronize com o Jira',
  'project-fields.project-work-tracked-picker.sync-with-jira-cancel-button': 'Cancelar',
  'project-fields.project-work-tracked-picker.sync-with-jira-connect-button': 'Conectar',
  'project-fields.project-work-tracked-picker.sync-with-jira-detail-selection':
    'Selecione as informações que você quer usar para este trabalho daqui para frente:',
  'project-fields.project-work-tracked-picker.sync-with-jira-header': 'Sincronizar esse projeto com Jira',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing': 'Sincronização de etiquetas',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing-description':
    'Sincronizar rótulos do Jira com marcadores no projeto',
  'project-fields.project-work-tracked-picker.sync-with-jira-project-name': 'Nome do projeto',
  'project-fields.project-work-tracked-picker.sync-with-jira-start-date': 'Data de início',
  'project-fields.project-work-tracked-picker.sync-with-jira-target-date': 'Data-alvo',
  'project-fields.project-work-tracked-picker.sync-with-jira-via-project': '{projectName} {viaProject}',
  'project-fields.project-work-tracked-picker.text-placeholder': 'Link de acompanhamento do trabalho',
  'project-fields.project-work-tracked-picker.work-tracked-picker-content':
    'Pesquise tickets do Jira ou adicione links para locais onde você está acompanhando o trabalho deste projeto.',
  'project-fields.project-work-tracked-picker.work-tracked-picker-title': 'Onde o trabalho é monitorado?',
  'project-fields.project-work-tracked.add-work-tracked-title': 'Adicionar tickets do Jira',
  'project-fields.project-work-tracked.empty-title': 'Nenhum ticket do Jira',
  'project-fields.project-work-tracked.linked-with-jira-label': 'Vinculado com Jira',
  'project-fields.project-work-tracked.sync-now-label': 'Sincronize agora',
  'project-fields.project-work-tracked.synced-with-jira-label': 'Sincronizado com Jira',
  'project-fields.project-work-tracked.title': 'Trabalho rastreado',
  'project-fields.related-project-picker.add-button-label': 'Adicionar',
  'project-fields.related-project-picker.cancel-button-label': 'Cancelar',
  'project-fields.related-project-picker.depended-by-option-label': 'Depende do projeto atual',
  'project-fields.related-project-picker.depends-on-option-label': 'O projeto atual depende de',
  'project-fields.related-project-picker.empty-state-description':
    'Encontre projetos relacionados para vincular a este projeto.',
  'project-fields.related-project-picker.empty-state-title': 'Pesquisar projetos',
  'project-fields.related-project-picker.project-relationship-type-label':
    'Selecione o tipo de relacionamento do projeto',
  'project-fields.related-project-picker.project-search-placeholder': 'Pesquisar projetos',
  'project-fields.related-project-picker.related-option-label': 'O projeto está relacionado a',
  'project-fields.related-project-picker.related-project-list-label': 'Projetos relacionados',
  'project-fields.related-projects.add-related-title': 'Adicionar projetos relacionados',
  'project-fields.related-projects.add-related-tooltip': 'Adicionar projetos relacionados ou dependentes',
  'project-fields.related-projects.dependent-by-projects-heading': 'Depende de',
  'project-fields.related-projects.dependent-on-projects-heading': 'Depende de',
  'project-fields.related-projects.empty-title': 'Nenhum projeto relacionado',
  'project-fields.related-projects.related-projects-heading': 'Relacionado a',
  'project-fields.related-projects.title': 'Relacionado',
  'project-fields.use-project-flags.generic-error-description': 'Algo deu errado, tente de novo em alguns minutos.',
  'project-fields.use-project-flags.generic-error-title': 'Algo deu errado',
  'project-fields.use-project-flags.project-links-add-failure-title': 'Não foi possível adicionar o link',
  'project-fields.use-project-flags.project-links-delete-failure-title': 'Não foi possível remover o link',
  'project-fields.use-project-flags.project-links-edit-failure-title': 'Não foi possível editar o link',
  'project-fields.use-project-flags.project-owner-change-error-header':
    'Não foi possível alterar o proprietário do projeto',
  'project-fields.use-project-flags.project-start-date-change-error-header':
    'Não foi possível atualizar a data de início do projeto',
  'project-fields.use-project-flags.project-tags-add-failure-title': 'Não foi possível adicionar o marcador',
  'project-fields.use-project-flags.project-tags-create-failure-title': 'Não foi possível criar o marcador',
  'project-fields.use-project-flags.project-tags-create-limit-failure-description':
    'O nome do marcador que você digitou é muito longo. Insira um nome do marcador com 255 caracteres ou menos.',
  'project-fields.use-project-flags.project-tags-create-limit-failure-title': 'Não foi possível criar o marcador',
  'project-fields.use-project-flags.project-tags-remove-failure-title': 'Não foi possível remover o marcador',
  'project-fields.use-project-flags.project-team-remove-failure-description': 'Erro ao remover equipe. Tente outra vez',
  'project-fields.use-project-flags.related-project-remove-failure-title':
    'Não foi possível remover o projeto relacionado',
};
